var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9584 2.04172C9.54173 1.55006 10.4834 1.55006 11.0501 2.04172L12.3667 3.16672C12.6167 3.37506 13.0917 3.55006 13.4251 3.55006H14.8417C15.7251 3.55006 16.4501 4.27506 16.4501 5.15839V6.57506C16.4501 6.90839 16.6251 7.37506 16.8334 7.62506L17.9584 8.94172C18.4501 9.52506 18.4501 10.4667 17.9584 11.0334L16.8334 12.3501C16.6251 12.6001 16.4501 13.0667 16.4501 13.4001V14.8167C16.4501 15.7001 15.7251 16.4251 14.8417 16.4251H13.4251C13.0917 16.4251 12.6251 16.6001 12.3751 16.8084L11.0584 17.9334C10.4751 18.4251 9.5334 18.4251 8.96673 17.9334L7.65007 16.8084C7.40007 16.6001 6.92507 16.4251 6.60007 16.4251H5.14173C4.2584 16.4251 3.5334 15.7001 3.5334 14.8167V13.3917C3.5334 13.0667 3.36673 12.5917 3.1584 12.3501L2.0334 11.0251C1.55007 10.4501 1.55007 9.51672 2.0334 8.94172L3.1584 7.61672C3.36673 7.36672 3.5334 6.90006 3.5334 6.57506V5.16672C3.5334 4.28339 4.2584 3.55839 5.14173 3.55839H6.5834C6.91673 3.55839 7.3834 3.38339 7.6334 3.17506L8.9584 2.04172Z",
    stroke: "#00AEEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.77502V10.8",
    stroke: "#00AEEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99561 13.3334H10.0031",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.c8b3767bfcda368a27de5761d7c07453.svg";
export { ForwardRef as ReactComponent };